import { instance } from './api';

export const getCurrencyExchange = (from, to) => instance.get(`/api/v1/currencies/exchange/${from}/${to}`);
